import React, { Component, Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router';
import { Container } from 'reactstrap';
import { NavMenu } from './components/NavMenu';
import { Home } from './components/Home';
import { About } from './components/About';
import { Work } from './components/Work';

const ReactProject = lazy(() => import('./components/college/reactProject'));
const MathematicsProject = lazy(() => import('./components/college/mathematicsProject'));
const CoOpProject = lazy(() => import('./components/college/coopProject'));
const CapstoneProject = lazy(() => import('./components/college/capstoneProject'));

function Loading() {
    return (
        <div className="min-vh-100 d-flex justify-content-center">
            <h2 className="text-info"><i>Loading...</i></h2>
        </div>
    );
}

/* 
If you are reading this, I understand that the class structure is outdated for a React application. 
For how simple this website is, it does not need to be updated to make use of functional components with hooks. 
If in the future I decide to add greater functionality, I understand that I will need to update the structure accordingly.
Thank you for reading.
*/
export class App extends Component {
    constructor(props) {
        super(props);
        this.state = { videoActive: true };
        // It makes the most sense to manage video state at this level given that video can appear
        // throughout the application, turning it on and off from wherever
        this.handleVideoToggle = this.handleVideoToggle.bind(this);
    }

    handleVideoToggle() {
        this.setState(prevState => ({ videoActive: !prevState.videoActive }));
    }

    render() {
        // why pass a function through multiple layers when I can pass a button?
        const videoToggle = <button type="button" onMouseUp={this.handleVideoToggle}
            className={"mx-auto text-light btn " + (this.state.videoActive ? "btn-danger" : "btn-accent")}>
                {this.state.videoActive ? "Hide" : "Show"} Video
            </button>;
        return (
            <div>
                <NavMenu />
                <Container>
                    <Suspense fallback={<Loading />}>
                        <Routes>
                            <Route path='/about' element={<About title="About Me" />} />
                            <Route path='/work' element={<Work title="Work History" />} />
                            <Route path='/react' element={<ReactProject projectName="React"
                                showVideo={this.state.videoActive}
                                toggle={videoToggle} />} />
                            <Route path='/mathematics' element={<MathematicsProject projectName="Mathematics"
                                showVideo={this.state.videoActive}
                                toggle={videoToggle} />} />
                            <Route path='/coop' element={<CoOpProject projectName="CoOp"
                                showVideo={this.state.videoActive}
                                toggle={videoToggle} />} />
                            <Route path='/capstone' element={<CapstoneProject projectName="Capstone"
                                showVideo={this.state.videoActive}
                                toggle={videoToggle} />} />
                            <Route exact path='/' element={<Home />} />
                        </Routes>
                    </Suspense>
                </Container>
            </div>
        );
    }
}